var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"outlined":"","loading":_vm.loading}},[_c('v-card-title',{staticClass:"d-flex justify-center text-center text-subtitle-1 font-weight-bold"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.title)}})]),(!_vm.isChart)?_c('v-spacer'):_vm._e(),_c('v-card-text',{staticClass:"d-flex justify-center card-text"},[_vm._t("content")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }